import {
  GET_APPLICANTS,
  ADD_APPLICANT,
  EDIT_APPLICANT,
  GET_APPLICANT,
  RESET_APPLICANT,
  GET_ALL_APPLICANTS,
  ERROR_APPLICANT,
} from "../types/applicant_type";

const initialState = {
  applicants: null,
  page: null,
  pages: null,
  applicant: null,
  total_applicants: 0,
  loading: true,
  error: {},
  applicant_message: null,
  all_applicants: null,
};

export const applicant_reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_APPLICANTS:
      return {
        ...state,
        applicants: payload.applicants,
        pages: payload.pages,
        page: payload.page,
        total_applicants: payload.count,
        loading: false,
        error: {},
      };
    case GET_ALL_APPLICANTS:
      return {
        ...state,
        all_applicants: payload,
        loading: false,
        error: {},
      };

    case RESET_APPLICANT:
      return {
        ...state,
        applicant: null,
        loading: true,
        error: {},
      };

    case ADD_APPLICANT:
      return {
        ...state,
        applicant_message: payload,
        loading: false,
        error: {},
      };
    case GET_APPLICANT:
      return {
        ...state,
        applicant: payload,
        loading: false,
        error: {},
      };
    case EDIT_APPLICANT:
      return {
        ...state,
        applicant_message: payload,
        loading: false,
        error: {},
      };
    case ERROR_APPLICANT:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};
                